export default "__VITE_ASSET__fESNvffe__"